<template>
  <div>
    <div class="playerbg">
      <div class="header">
        <div class="title">
            <div class="han">培训列表</div>
            <div class="eng">Train</div>
        </div>
        <div class="search">
            <input class="search-input" type="text" placeholder="请输入培训名称搜索" v-model="searchVal">
            <span style="padding: 15px;background: #244e8f;color:white;cursor: pointer;" @click="search()">搜索</span>
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" >
        </div>
        <div class="status">
            <div class="status-cell" v-for="(status,index) in statusList" :key="index" :class="activeStatus == index? 'activeBg':'inactiveBg' " @click="statusSwitch(index,status.code)">{{status.name}}</div>
        </div>
     </div>
    </div>
  <!--近期赛事-->
  <div class="match-list-warp">
    <div class="match-list">
      <div class="clearFloat main-width">
        <div
          class="width-50"
          v-for="(item, index) in websitePageMatchList"
          :key="index"
          @click="matchClick(item.id, item.programId)"
        >
          <div class="match-warp" style="margin-bottom: 15px;height: 120px;">
            <img class="logo" :src="item.logo" />
            <div class="match-text">
              <p class="title">{{ item.title || "未知" }}</p>
              <p class="date-img">
                <label class="date">
                  <a-icon type="clock-circle" />&ensp;{{(item.beginTime || "").slice(0, 10)}} ~ {{ (item.endTime || "").slice(0, 10) }}
                </label>
              </p>
              <p class="date-img">
                <label class="date">
                  <a-icon type="environment" />&ensp;{{item.address || "未知"}}
                </label>
              </p>
            </div>
          </div>
          <div
            class="btn"
            :style="'bottom: 15px;border-bottom: 35px solid ' + matchFun.statusColor(item.status)"
          >
            {{ matchFun.statusText(item.status) }}
          </div>
        </div>
        <div class="empty" v-if="websitePageMatchList.length <= 0">
          暂无数据
        </div>
      </div>
    </div>
    <div class="pages" style="text-align: center;" v-if="websitePageMatchList.length !==0">
      <a-pagination v-model="current" :total="totalNum" :defaultPageSize="params.pageSize" show-less-items @change="onChange"/>
    </div>
  </div>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'ExaminCoach',
  data () {
    return {
      matchFun: matchFun,
      websitePageMatchList: [], // 赛事列表，
      totalNum: 0,
      params: {
        programId: this.$route.query.programId,
        pageNum: 1,
        pageSize: 20,
        title: '',
        type: 2,
        status: -1
      },
      statusList: [
        {code: -1, name: '全部'},
        {code: 1, name: '计划中', bgColor: '#b99523'},
        {code: 2, name: '报名中', bgColor: '#F73C13'},
        {code: 3, name: '进行中', bgColor: '#008000'},
        {code: 4, name: '已结束', bgColor: '#BBB'}
      ],
      current: 1,
      searchVal: null,
      activeStatus: 0
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.examin.examinPointList(this.params).then(res => {
        if (res.status === 0) {
          this.websitePageMatchList = res.data
          this.totalNum = res.total
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onChange (page) {
      this.params.pageNum = page
      this.findData()
    },
    search () {
      this.params.pageNum = 1
      this.params.title = ''
      if (this.searchVal !== '' && this.searchVal !== undefined && this.searchVal !== null) {
        this.params.title = this.searchVal
      }
      this.findData()
    },
    statusSwitch (index, code) {
      this.params.pageNum = 1
      this.activeStatus = index
      this.params.status = code
      this.findData()
    },
    matchClick (id, programId) {
      this.$router.push({name: 'EventWeaponSign', query: {id: id, programId: this.$route.query.programId}})
    }
  }
}
</script>

<style lang="scss" scoped>
.inactiveBg{
  color: #000;
}
.activeBg{
  color: #244e8f;
  font-weight: bold;
}
.playerbg{
  height: 200px;
  padding-top: 40px;
  background-image: url('../../../assets/weapon/playertopbg.png');
}
.header{
  width: 1200px;
  padding: 30px 0 20px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgb(236, 236, 236);
  border-radius: 10px;
  padding: 40px;
}
.search{
  // background-color: green;
  position: relative;
}
.search-input{
  width: 350px;
  padding-left: 50px;
  margin-left: 30px;
  border: 0px;
  height: 50px;
  outline: none;
  border-bottom: 1px solid #b3b3b3;
  font-size: 13px;
}
.search-icon{
  width: 17px;
  position:absolute;
  left: 40px;
  top: 15px;
}
.han{
  font-size: 20px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.title{
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  // margin-bottom: 47px;
}
.status{
  flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #000;
  // background-color: red;
}
.status-cell{
  // width: 18%;
  flex: 1;
  margin-right: 8px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  padding: 5px 0;
  cursor: pointer;
}
.head-font{
  width: 1200px;margin: 0 auto;margin-top:40px;margin-bottom:15px;font-size:18px;color:#000;
}
.match-list{
  overflow: hidden;
}
/**赛事列表*/
.match-list-warp {
  background-color: #f4f4f4;
  padding-top: 10px;
  margin-bottom: 40px;
  padding-bottom: 10px;
  overflow: hidden;
}
.match-list-warp .width-50 {
  width: 50%;
  float: left;
  position: relative;
}
.match-list-warp .width-50:nth-child(even) .btn {
  margin-left: 4%;
}
.match-list-warp .match-warp {
  background-color: #fff;
  width: 96%;
  height: 150px;
  margin-top: 10px;
  margin-bottom: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  padding: 0 20px;
}
.match-list-warp .match-warp .logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
}
.match-list-warp .match-warp .match-text {
  width: 436px;
  height: 100px;
}
.match-list-warp .match-warp .match-text p.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  overflow: hidden;
  height: 30px;
}
.match-list-warp .match-warp .match-text p {
  margin: 0;
  padding: 0;
}
.match-list-warp .match-warp .match-text p img.icon {
  height: 17px;
  width: 17px;
  margin-right: 10px;
}
.match-list-warp .match-warp .match-text .date-img {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 5px;
}
.match-list-warp .match-warp .match-text .date-img .date {
  -webkit-box-flex: 1.5;
      -ms-flex: 1.5;
          flex: 1.5;
}
.match-list-warp .match-warp .match-text .date-img label {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  color: #999999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.match-list-warp .match-warp .match-text .date-img .center {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.match-list-warp .match-warp .match-text .date-img .right {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.match-list-warp .btn {
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 4%;
  border-bottom: 35px solid #f73c13;
  border-left: 15px solid rgba(255, 255, 255, 0);
  height: 0;
  width: 120px;
  color: #fff;
  text-align: center;
  line-height: 35px;
}
.match-list-warp .btn:hover {
  color: #eee;
  font-size: 16px;
}
.match-list-warp .more {
  color: #000;
  text-align: center;
  font-weight: bold;
  line-height: 30px;
  margin-top: 30px;
  font-size: 16px;
  cursor: pointer;
}
.match-list-warp .more:hover {
  color: #999999;
}
.match-list-warp .empty {
  text-align: center;
  color: #999;
  line-height: 150px;
  font-size: 16px;
}
.main-width {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/ProgramReferee.vue